module.exports = __webpack_public_path__ + "static/johnnieri-df10f708a374b2857db5d4e1df11c7de.jpg";